import { extend, $, $$, addEvent, hasParentsClass, targetContainerVisibility } from './helper-functions'

export class PageHeader {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      block: '.page-header',
      bigHeaderImage: '.big-header-image',
      mainNavigationActive: '.main-navigation--active',
      userType: '.page-header__user-type',
      userTypeActive: '.page-header__user-type.is--active',
      userTypeSubmenuButton: '.page-header__user-type-list button',
      page: '.page'
    }, selectors)

    this.classes = extend({
      scrollHidden: 'page-header--scroll-hidden',
      noTransparent: 'page-header--no-transparent',
      active: 'is--active',
      pageBlur: 'page--blur-content-footer',
      userType: 'page-header__user-type',
      userTypePopup: 'page-header__user-type-popup'
    }, classes)

    this.settings = extend({
      scrollY: window.scrollY,
      lastScrollY: 0
    })

    this.$pageHeader = $(this.selectors.block)
    this.$userType = $(this.selectors.userType)
    this.$userTypeSubmenuButton = $$(this.selectors.userTypeSubmenuButton)
    this.$page = $(this.selectors.page)
  }

  init () {
    targetContainerVisibility(this.$userType)
    this.$userTypeSubmenuButton.forEach(userTypSubmenuButton => {
      targetContainerVisibility(userTypSubmenuButton)
    })
    this.addEvents()
  }

  addEvents () {
    if (window.innerWidth >= 1304) {
      addEvent(window, 'scroll', () => {
        this.settings.lastScrollY = this.settings.scrollY
        this.settings.scrollY = window.scrollY
        const headerHeight = this.$pageHeader.offsetHeight

        if (window.scrollY < headerHeight || $$(this.selectors.mainNavigationActive).length > 0 || this.$userType) {
          this.$pageHeader.classList.remove(this.classes.scrollHidden)
        } else if (window.scrollY > this.settings.lastScrollY && (window.scrollY - this.settings.lastScrollY) > 10) {
          this.$pageHeader.classList.add(this.classes.scrollHidden)
        } else if (window.scrollY < this.settings.lastScrollY && (this.settings.lastScrollY - window.scrollY) > 5) {
          this.$pageHeader.classList.remove(this.classes.scrollHidden)
        }
      })
    }

    addEvent(window, 'scroll', () => {
      const bigHeaderImage = $(this.selectors.bigHeaderImage)
      const headerHeight = this.$pageHeader.offsetHeight

      if (bigHeaderImage && window.scrollY > (bigHeaderImage.offsetHeight - headerHeight)) {
        this.$pageHeader.classList.add(this.classes.noTransparent)
      } else {
        this.$pageHeader.classList.remove(this.classes.noTransparent)
      }
    })

    addEvent(this.$userType, 'click', () => {
      this.$userType.classList.toggle(this.classes.active)
      this.$userType.setAttribute('aria-expanded', !!this.$userType.classList.contains(this.classes.active))
      targetContainerVisibility(this.$userType)

      window.setTimeout(() => {
        if (window.innerWidth > 1343) {
          this.$page.classList.toggle(this.classes.pageBlur, this.$userType.classList.contains(this.classes.active))
        }
      }, 100)
    })

    this.$userTypeSubmenuButton.forEach(userTypSubmenuButton => {
      addEvent(userTypSubmenuButton, 'click', () => {
        userTypSubmenuButton.classList.toggle(this.classes.active)
        userTypSubmenuButton.setAttribute('aria-expanded', !!userTypSubmenuButton.classList.contains(this.classes.active))
        targetContainerVisibility(userTypSubmenuButton)
      })
    })

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.closeUserType()
      }

      if (event.key === 'Tab') {
        if (!hasParentsClass(event.target, this.classes.userType) && !hasParentsClass(event.target, this.classes.userTypePopup)) {
          this.closeUserType()
        }
      }
    })

    addEvent($('body'), 'click', (event) => {
      if (!hasParentsClass(event.target, this.classes.userType) && !hasParentsClass(event.target, this.classes.userTypePopup) && this.$userType.classList.contains(this.classes.active)) {
        this.closeUserType()
      }
    })
  }

  closeUserType () {
    this.$userType.classList.remove(this.classes.active)
    this.$userType.setAttribute('aria-expanded', false)
    targetContainerVisibility(this.$userType)

    this.$userTypeSubmenuButton.forEach(userTypSubmenuButton => {
      userTypSubmenuButton.classList.remove(this.classes.active)
      userTypSubmenuButton.setAttribute('aria-expanded', false)
      targetContainerVisibility(userTypSubmenuButton)
    })

    this.$page.classList.remove(this.classes.pageBlur)
  }
}

export default PageHeader
